import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams, HttpClientJsonpModule } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppTokenHandler } from '../common/app-token-handler';

@Injectable()
export class DataService {
    private apiUrl: string;
    private httpHeaderFileDownload: any;
    private secretKey: string = environment.appcode;
    constructor(private appToken: AppTokenHandler, private http: HttpClient) {
        this.apiUrl = environment.serviceBaseUrl;
    }
    Login(DigiPitchID?: number, azToken: string = '') {
        const body: any = null;
        let params = new HttpParams();
        params = params.append('DigiPitchID', DigiPitchID.toString());
        const httpLoginPostOptions = {
            headers: new HttpHeaders({
                'azure_token': azToken,
                'Content-Type': 'application/json'
            }),
            withCredentials: true,
            params: params
        };
        return this.http.post(environment.tokenPath, JSON.stringify(body), httpLoginPostOptions).pipe(catchError(this.handleError));
    }
    LoginWithEmail(Email: string) {
        const body: any = null;
        let params = new HttpParams();
        params = params.append('Email', Email);
        const httpLoginPostOptions = {
            withCredentials: true,
            params: params
        };
        return this.http.post(environment.tokenPath, JSON.stringify(body), httpLoginPostOptions).pipe(catchError(this.handleError));
    }
    GetEmployeeByName(_url: string, empname: string) {
        empname = empname.replace(/ /g, '-');
        _url = environment.serviceBaseUrl + _url + empname;
        return this.http.get<any>(_url, { withCredentials: true });
    }
    GetData(_url: string) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    GetDataById(_url: string, _id: any) {
        _url = environment.serviceBaseUrl + _url + "/" + _id;
        return this.http.get(_url, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    PostData(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        //"Accept-Charset", (document.charset||document.characterSet)
        return this.http.post(_url, _postdata, { withCredentials: true }).pipe(catchError(this.handleError));
    }
    DownloadFileWithPost(_url: string, _postdata: any) {
        _url = environment.serviceBaseUrl + _url;
        return this.http.post(_url, _postdata, { withCredentials: true, responseType: 'blob' })
            .pipe(
        );
    }
    ContainsSpecialCharacters(searchString: string) {
        let IsValidString: boolean = true;
        if (searchString.length > 0) {
            let regex = /^[A-Za-z0-9 ]+$/;
            IsValidString = regex.test(searchString);
        }
        return (IsValidString == true ? false : true);
    }
    private handleError(error: Response) {
        return throwError(error);
    }
}

@Injectable()
export class UIBlockingStatus {
    private IsBlocked: BehaviorSubject<boolean>;
    constructor() {
        this.IsBlocked = new BehaviorSubject(false);
    }

    setStatus(_IsBlocked: boolean) {
        this.IsBlocked.next(_IsBlocked);
    }

    getStatus(): Observable<boolean> {
        return this.IsBlocked.asObservable();
    }
}